"use client";

import { useEffect } from "react";
import { PostHogProvider } from "@posthog/react";
import { POSTHOG_KEY, POSTHOG_HOST, initPixels } from "@/lib/analytics";

const options = {
  api_host: POSTHOG_HOST,
  capture_pageview: true,
} as const;

export function Providers({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    initPixels();
  }, []);

  return (
    <PostHogProvider apiKey={POSTHOG_KEY} options={options}>
      {children}
    </PostHogProvider>
  );
}
